import {
	DEFAULT_LLM_MODEL,
	MARKETING_URLS,
	SESSION_TIMEOUT_MS,
} from "./config/constants";
import { env } from "./config/env";

function getAuthRedirectUri(): string {
	if (typeof window !== "undefined") {
		return `${window.location.origin}/callback`;
	}

	return "app://localhost/callback";
}

const config = {
	// deployment
	wsUrl: env.VITE_WS_URL,
	graphqlUrl: env.VITE_GRAPHQL_URL,
	graphqlWsUrl: env.VITE_GRAPHQL_URL,
	restApiUrl: env.VITE_API_URL,
	llmBaseUrl: env.VITE_LLM_BASE_URL,
	llmModel: env.VITE_LLM_MODEL ?? DEFAULT_LLM_MODEL,
	mcpHttpUrl: env.VITE_MCP_HTTP_URL,
	s3: {
		region: env.VITE_S3_REGION,
		bucket: env.VITE_S3_BUCKET_NAME,
	},

	// auth
	auth: {
		domain: env.VITE_AUTH0_DOMAIN,
		clientId: env.VITE_AUTH0_CLIENT_ID,
		get redirectUri() {
			return getAuthRedirectUri();
		},
		audience: env.VITE_AUTH0_AUDIENCE ?? env.VITE_GRAPHQL_URL,
	},

	// feature flags
	features: {
		localSync: env.VITE_ENABLE_LOCAL_SYNC,
		debugMenu: env.VITE_ENABLE_DEBUG_MENU,
		debugMode: env.VITE_DEBUG_MODE,
		desktopBrowserLogin: env.VITE_ENABLE_DESKTOP_BROWSER_LOGIN,
	},

	// integrations
	stripePublishableKey: env.VITE_STRIPE_PUBLISHABLE_KEY,
	sentry: {
		dsn: env.VITE_SENTRY_DSN,
		environment: env.VITE_SENTRY_ENVIRONMENT_NAME,
	},
	posthog: {
		key: env.VITE_PUBLIC_POSTHOG_KEY,
		host: env.VITE_PUBLIC_POSTHOG_HOST,
	},
	googleAnalyticsId: env.VITE_GOOGLE_ANALYTICS_ID,
	collectNotesUrl: env.VITE_COLLECT_NOTES_URL,

	// desktop
	updateChannel: env.VITE_UPDATE_CHANNEL,
	storeUrl: env.VITE_STORE_URL,
	desktopDownloadUrl: env.VITE_DESKTOP_DOWNLOAD_URL,

	// static
	...MARKETING_URLS,
	sessionTimeoutMs: SESSION_TIMEOUT_MS,
	appVersion: env.VITE_APP_VERSION,
};

export type AppConfig = typeof config;

export default config;
